module.exports = __webpack_public_path__ + "img/listas_reports.57674789.png";